import { render, staticRenderFns } from "./Reservation.vue?vue&type=template&id=3148174c"
import script from "./Reservation.vue?vue&type=script&lang=js"
export * from "./Reservation.vue?vue&type=script&lang=js"
import style0 from "./Reservation.vue?vue&type=style&index=0&id=3148174c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports